import { useQuery } from '@tanstack/react-query';

import { getLists, listKeys } from './itemsApi.ts';

/**
 * A group's lists.
 *
 * Read in two places — the header menu, to say what the Lists entry would open, and
 * GroupView, which shows one of them — so it is one query key rather than two inline
 * copies that could drift in their options. Both callers share a single fetch.
 *
 * Takes an optional id so the header can call it before a group has been chosen.
 */
export function useLists(groupId: string | undefined) {
  return useQuery({
    queryKey: listKeys.ofGroup(groupId ?? ''),
    queryFn: () => getLists(groupId ?? ''),
    enabled: groupId !== undefined,
  });
}
